import { render } from "./ServiceDetailCloudConsulting.vue?vue&type=template&id=18b3fd0e"
import script from "./ServiceDetailCloudConsulting.vue?vue&type=script&lang=js"
export * from "./ServiceDetailCloudConsulting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__